import React, {useEffect, useState} from 'react';
import './App.css';

import background1 from "./Reply-Background-2-1030x579.af91a26ba4df30ebd7c1.png"
import background2 from "./3-10-1030x579.1f3f7737e877acf611c1.png"
import background3 from "./40-1030x579.af61b1e8cc81d53b5d54.png"
import background4 from "./50-1030x579.d5b74a5df74ba6dea206.png"
import logo from "./Technology-Reply-LOGO_Negative-RGB_Transparent-1.11e4a76aff6f59c248cb.png"

function App() {
    const listOfBackgrounds = [background1,
        background2,
        background3,
        background4
    ]
    const getRandomInt = (): number => {
        return Math.floor(Math.random() * 4);
    };

    const [background, setBackground] = useState("")
    useEffect(() => {
        setBackground(listOfBackgrounds[getRandomInt()])
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <div id={"appContainer"} style={{backgroundImage:`url(${background})`, backgroundSize: 'cover',
            backgroundPosition: 'center',
            height: '100vh',}} className="App">
            <div style={{height: '100vh',width:"100%",position:"absolute",top:0,opacity:0.6,background:"#0a0a0a"}}/>

            <section className="section section-body">
                <div className="logo-wrapper image">
                    <img className={"graphic-logo"}
                        src={logo}
                         alt="logo"/>
                </div>
                <h2 className="cmp-title animated ">
                    <br/>
                    The selected web page is not available
                    <br/>
                    from your current geographic location.
                    <br/>
                    We apologize for any inconvenience this may cause.
                    <br/>
                </h2>
            </section>
            {/*<div className={"main"}>*/}
            {/*    <div className={"svg"}><AnimationSVG></AnimationSVG></div>*/}
            {/*    <br/>*/}
            {/*    <div className={"text"} >*/}
            {/*        <br/>*/}
            {/*        The selected web page is not available*/}
            {/*        <br/>*/}
            {/*        from your current geographic location.*/}
            {/*        <br/>*/}
            {/*        We apologize for any inconvenience this may cause.*/}
            {/*        <br/>*/}

            {/*    </div>*/}
            {/*</div>*/}
        </div>
    );
}

export default App;
